module.exports = __webpack_public_path__ + "media/no-4a488028.mp4";